<template src='./ListadoCategorias.html'></template>
<script>
import { serverBus } from "../../main";
import TarjetaMiniatura from "../TarjetaMiniatura/TarjetaMiniatura";
export default {
  data() {
    return {
      verCategoria: "",
      banderaFormulariosLlenosTipoMomento: false,
      formularios: [],
      accordion: true,
      focusable: true,
      banderaVerCategoria: false,
      panel: [],
    };
  },
  beforeUpdate() {

  },
  created() {

  },
  mounted() {
    // serverBus.$on("verCategoriaFormularioAcordeon", nombreCategoria => {
    //   this.formulariosLlenosTipoMomentoAcordeon = [];
    //   this.consultarResumenEncuentrosPorTipoAcordeon(nombreCategoria);
    // });
  },
  computed: {
    getConsultarEncuentro() {
      if (this.$store.getters.getConsultarEncuentro != null && this.banderaVerCategoria === false) {
        this.panel = this.formulariosMomentosllenos.indexOf(this.formulariosMomentosllenos.filter(elemento => elemento.nombre == this.verCategoria)[0]
        );
      }
      return this.$store.getters.getConsultarEncuentro;
    }
  },
  watch: {
    getConsultarEncuentro() {}
  },
  props: {
    formulariosMomentosllenos: {
      type: Array,
      required: true
    },
    formulariosLlenosTipoMomento: {
      required: true
    },
    banderaOcultarMas: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  components: {
    TarjetaMiniatura
  },
  methods: {
    agregarFormulario(nombreFormulario, coleccion) {
      this.$store.dispatch('setIdFormulario', null);
      this.$store.dispatch("setVariablesFormularios", []);
      this.$store.dispatch("setNombreFormulario", nombreFormulario);
      this.$store.dispatch("setColeccion", coleccion);
      this.$store.dispatch("setBanderaBotonMas", true);
      serverBus.$emit("crearFormularioNuevo");
    },
    verCategoriaFormulario: function(nombreCategoria,coleccion) {
      this.banderaVerCategoria = true;

      // this.$emit("coleccion", this.coleccion);
      serverBus.$emit("verCategoriaFormulario", nombreCategoria,coleccion);
    }
  }
};
</script>
<style src='./ListadoCategorias.scss' lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/components/ListadoCategorias/ListadoCategorias.vue